// extracted by mini-css-extract-plugin
export default {"container":"MK-z","topReviewHeading":"NK-z","criticalReview":"OK-z","favorableReview":"PK-z","vsSeparator":"QK-z"};